import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { BagProvider } from './contexts/BagContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AddressProvider } from './contexts/AddressContext';
import Header from './components/Layout/Header';
import SEO from './components/Layout/SEO';
import AddressBanner from './components/Address/AddressBanner';
import Home from './pages/Home';
import Login from './components/Auth/Login';
import ProductList from './components/Products/ProductList';
import Cart from './components/Cart/Cart';
import Checkout from './components/Cart/Checkout';
import Orders from './components/Orders/Orders';
import OrderSuccess from './pages/OrderSuccess';
import AddAddress from './pages/AddAddress';
import './App.css';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <LanguageProvider>
          <AuthProvider>
            <AddressProvider>
              <BagProvider>
                <CartProvider>
                  <div className="App">
                    <SEO />
                    <Header />
                    <AddressBanner />
                    <main>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/products" element={<ProductList />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/add-address" element={<AddAddress />} />
                        <Route
                          path="/checkout"
                          element={
                            <ProtectedRoute>
                              <Checkout />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/orders"
                          element={
                            <ProtectedRoute>
                              <Orders />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/order-success"
                          element={
                            <ProtectedRoute>
                              <OrderSuccess />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </main>
                  </div>
                </CartProvider>
              </BagProvider>
            </AddressProvider>
          </AuthProvider>
        </LanguageProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
